export namespace AuthMessage {
  export function convertMessage(code: string): string {
    switch (code) {
      case "auth/user-disabled": {
        return "Your user is disabled. Contact support@magson.no for support.";
      }
      case "auth/user-not-found": {
        return "We could not find this user.";
      }
      case "auth/network-request-failed": {
        return "There seems to be a problem with your internet. Try again later.";
      }
      case "auth/too-many-requests": {
        return "Your device has been temporarly blocked due to many attempts.";
      }
      case "auth/unauthorized-domain": {
        return "This site is blocked by Foko. Get out of there ASAP!";
      }
      case "auth/wrong-password": {
        return "Wrong password.";
      }
      case "auth/weak-password": {
        return "Password is too weak. It should be at least 6 characters long.";
      }
      case "auth/email-already-in-use": {
        return "This email is already in use.";
      }
      case "auth/invalid-email": {
        return "This email is invalid.";
      }
      default: {
        return "An error has occured. Please try again later.";
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/extra/auth-message.ts